<template>
  <div class="d-flex align-center">
    <icon-button
      icon="fa-angle-left"
      aria-label="Previous"
      @click="goToPreviousMonth"
      :disabled="disabled"
    />
    <div>{{ formattedValue }}</div>
    <date-picker-dropdown
      :value="value"
      @input="value => $emit('input', value)"
      type="month"
      :max="maxDateForPicker"
    >
      <template #activator="{ on }">
        <v-btn icon color="primary" v-on="on" :disabled="disabled">
          <v-icon>fa-calendar</v-icon>
        </v-btn>
      </template>
    </date-picker-dropdown>
    <icon-button
      icon="fa-angle-right"
      aria-label="Next"
      @click="goToNextMonth"
      :disabled="isNextMonthDisabled"
    />
  </div>
</template>

<script>
import { addMonths, isBefore, parse, startOfMonth, subMonths } from 'date-fns';

import DatePickerDropdown from '@/components/atoms/DatePickerDropdown';
import IconButton from '@/components/atoms/IconButton';
import dateTimeFormatting from '@/mixins/dateTimeFormatting';

export default {
  name: 'month-picker',
  mixins: [dateTimeFormatting],
  components: {
    DatePickerDropdown,
    IconButton,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
    maxDate: {
      type: String,
      // Format: 'yyyy-MM' (e.g. '2026-04')
    },
  },
  computed: {
    formattedValue() {
      return this.formatYearMonth(this.value);
    },
    isNextMonthDisabled() {
      if (this.disabled) return true;
      if (!this.maxDate) return false;
      const valueMonth = startOfMonth(parse(this.value, 'yyyy-MM', new Date()));
      const maxMonth = startOfMonth(parse(this.maxDate, 'yyyy-MM', new Date()));
      return !isBefore(valueMonth, maxMonth);
    },
    // 月選択カレンダーの最大日付を設定（未来の月選択を防ぐため）
    maxDateForPicker() {
      return this.maxDate ? `${this.maxDate}-01` : undefined;
    },
  },
  methods: {
    goToPreviousMonth() {
      const monthDate = parse(this.value, 'yyyy-MM', new Date());
      this.$emit('input', this.formatMonthForApi(subMonths(monthDate, 1)));
    },
    goToNextMonth() {
      const monthDate = parse(this.value, 'yyyy-MM', new Date());
      this.$emit('input', this.formatMonthForApi(addMonths(monthDate, 1)));
    },
  },
};
</script>

<style scoped lang="sass">
</style>
